import React, { useContext, useState, useEffect } from 'react';
import { CurrencyService } from 'core/api/services/currency';
import axios from 'axios';

import { useAuth } from 'core/contexts/auth';

const CurrencyContext = React.createContext(null);

export const CurrencyProvider = ({ children }) => {
    const defaultCurrency = window.localStorage.getItem('currency') || 'COP'; // es el valor default en pesos colombianos
    const [currency, setCurrency] = useState(defaultCurrency);
    const [exchange, setExchange] = useState(0);
    const { userInfo } = useAuth();

    const [loading, setLoading] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const loadCurrencyData = () => {
            const currency = window.localStorage.getItem('currency') || userInfo?.triper?.currency || defaultCurrency;

            if (currency) {
                setCurrency(currency);
            } else {
                window.localStorage.setItem('currency', defaultCurrency);
                setCurrency(defaultCurrency);
            }
        };

        loadCurrencyData();
    }, [userInfo?.triper?.currency, defaultCurrency]);

    const getCurrencies = async (options) => {
        try {
            setLoading(true);
            const result = await CurrencyService.getList(options);

            if (!result) {
                throw new Error();
            }
            setCurrencies(result.currencies);
            setTotal(result.total);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const getCurrencyExchange = async (fromCurrency, toCurrency) => {
        const options = {
            method: 'GET',
            url: 'https://currency-exchange.p.rapidapi.com/exchange',
            params: {
                to: toCurrency.toUpperCase() || 'COP',
                from: fromCurrency.toUpperCase() || 'USD',
                q: '1.0',
            },
            headers: {
                'x-rapidapi-key': '6dd4a3edc8msh9f07d0593500b13p1af642jsnadd7939a04c9',
                'x-rapidapi-host': 'currency-exchange.p.rapidapi.com',
            },
        };
        const response = await axios.request(options);
        // TODO: es necesario el setter?
        setExchange(response.data);
        return response.data;
    };

    return (
        <CurrencyContext.Provider
            value={{
                exchange,
                currency,
                getCurrencyExchange,
                setCurrency,
                loading,
                total,
                currencies,
                getCurrencies,
            }}
        >
            {children}
        </CurrencyContext.Provider>
    );
};

CurrencyProvider.displayName = 'CurrencyProvider';

export const useCurrency = () => useContext(CurrencyContext);
